<div class="contents-area" (dragstart)="onDragstartBody($event)" style="width: calc(100vw - 300px);">
  <div class="split_two_part">
    <div id="vb_pageIndex" [hidden]="kymw2400Model.hiddenAllListFlg" forcedEnabledMode="true" class="block-column">
      <!-- 初期表示 -->
      <div>
        <h1>ページテンプレート一覧</h1>
        <wj-flex-grid class="wj-flex-grid" style="max-width:850px;width:100%;" #dtg_PageTemplateList
          id="dtg_PageTemplateList" [frozenColumns]="1" [itemsSource]="kymw2400Model.pageTemplateList"
          [isReadOnly]="true" [deferResizing]="true" [allowDragging]="'None'" [allowSorting]="true"
          [headersVisibility]="'Column'" [selectionMode]="'Row'" forcedEnabledMode="true"
          (click)="eventPageTemplateListHandler()" [tabindex]="-1">
          <wj-flex-grid-column [minWidth]="5" [header]="'テンプレート名'" [width]="188" [binding]="'PageTemplateName'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'ページ領域始点X'" [width]="130" [binding]="'PageAreaX'"
            [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <div [align]="'right'">{{cell.item.PageAreaX | number:'1.1-1'}}</div>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'ページ領域始点Y'" [width]="130" [binding]="'PageAreaY'"
            [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <div [align]="'right'">{{cell.item.PageAreaY | number:'1.1-1'}}</div>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'ページ領域幅'" [width]="106" [binding]="'PageAreaWidth'"
            [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <div [align]="'right'">{{cell.item.PageAreaWidth | number:'1.1-2'}}</div>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'ページ領域高さ'" [width]="117" [binding]="'PageAreaHeight'"
            [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <div [align]="'right'">{{cell.item.PageAreaHeight | number:'1.1-2'}}</div>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'X分割数'" [width]="80" [format]="'n1'" [binding]="'DivW'"
            [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <div [align]="'right'">{{cell.item.DivW | number:'1.1-1'}}</div>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'Y分割数'" [width]="80" [format]="'n1'" [binding]="'DivH'"
            [align]="'right'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <div [align]="'right'">{{cell.item.DivH | number:'1.1-1'}}</div>
            </ng-template>
          </wj-flex-grid-column>
        </wj-flex-grid>
      </div>
      <app-section-info id="si_SectionInfo" [selectedSectionInfo]="kymw2400Model.selectedSectionInfo">
      </app-section-info>
    </div>
    <!-- 新規追加画面 -->
    <div id="vbx_NewPage" [hidden]="kymw2400Model.hiddenNewPageFlg">
      <h1>ページテンプレート新規作成</h1>
      <div class="block-column">
        <app-page-form id="pf_newPage" (clickNewSectionCreate)="eventCreateNewSectinHandler()"
          [pageData]="kymw2400Model.newTemplateData">
        </app-page-form>
        <app-section-form id="sf_newPage"
          [selectedSectionInfo]="kymw2400Model.selectedSectionInfo" (clickDeleteSection)="eventDeleteSectionHandler()"></app-section-form>
      </div>
    </div>
    <!-- 編集画面 -->
    <div id="vbx_EditPage" [hidden]="kymw2400Model.hiddenEditPageFlg">
      <h1>ページテンプレート編集</h1>
      <div class="block-column">
        <app-page-form id="pf_editPage" (clickNewSectionCreate)="eventCreateNewSectinHandler()"
          [pageData]="kymw2400Model.selectedPageInfo">
        </app-page-form>
        <app-section-form id="sf_editPage" [selectedSectionInfo]="kymw2400Model.selectedSectionInfo" (clickDeleteSection)="eventDeleteSectionHandler()">
        </app-section-form>
      </div>
    </div>
    <app-page-template-window id="tw_pagePattern" #tw_pagePattern (sectionClick)="sectionClickHandler()">
    </app-page-template-window>
  </div>
</div>

<footer class="footer-buttons">
  <ng-container *ngIf="!kymw2400Model.hiddenAllListFlg">
    <button id="btn_EditTemplate" class="btn-secondary" [disabled]="kymw2400Model.disabledEditTemplate"
      (click)="eventEditTemplateHandler()" [tabindex]="0">テンプレートを編集</button>
    <button id="btn_NewTemplate" class="btn-primary" [disabled]="kymw2400Model.disabledNewTemplate"
      (click)="eventNewPageCreateHandler()" [tabindex]="0">テンプレートを追加</button>
  </ng-container>
  <ng-container *ngIf="!kymw2400Model.hiddenEditPageFlg">
    <div class="element-row">
      <button class="btn-tartiary warning" id="btn_DeleteTemplate" #btn_DeleteTemplate
        (click)="eventDeleteHandler()">このテンプレートを削除</button>
      <button class="btn-tartiary" id="btn_EditPageCancel" (click)="eventCancelHandler()">ページテンプレート一覧に戻る</button>
    </div>
    <button class="btn-primary" id="btn_EditPageUpdate" (click)="eventEditPageUpdateHandler()">設定</button>
  </ng-container>
  <ng-container *ngIf="!kymw2400Model.hiddenNewPageFlg">
    <button id="btn_NewPageCancel" class="btn-tartiary" (click)="eventCancelHandler()">ページテンプレート一覧に戻る</button>
    <button id="btn_NewPageRegist" #btn_NewPageRegist class="btn-primary"
      (click)="eventNewPageRegistHandler()">確認</button>
  </ng-container>
</footer>